module.exports = __webpack_public_path__ + "media/images/basic_logos/remove-b417c338daec8bde184359a1f346e39d.png";